import React from "react";
import config from "../config"

class Homepage extends React.Component {
    constructor(props) {
    super(props);
    this.state = {
      loginResult: '',
      hasPermission: this.props.hasPermission !== undefined ? this.props.hasPermission : true
    };
  }

  componentDidMount() {
    this.checkMsGraphApiStatus();
  }

  checkMsGraphApiStatus() {
    // Use props hasPermission if available, otherwise check localStorage
    if (this.props.hasPermission !== undefined) {
      this.setState({ hasPermission: this.props.hasPermission });
      if (!this.props.hasPermission) {
        if (window.$) {
          window.$('#logoutModal').modal('show');
        }
      }
      return;
    }

    const msGraphStatus = localStorage.getItem('msGraphApiStatus');
    if (msGraphStatus) {
      try {
        const statusData = JSON.parse(msGraphStatus);
        if (statusData.error && statusData.status) {
          // Do not remove the status to keep permission info
          this.setState({ hasPermission: false });
          if (window.$) {
            window.$('#logoutModal').modal('show');
          }
        }
      } catch (error) {
        console.error('MS Graph api error: ', error);
        // Only remove on parsing error, not authorization error
        localStorage.removeItem('msGraphApiStatus');
      }
    }
  }

  componentDidUpdate(prevProps) {
    // Check if hasPermission prop has changed
    if (prevProps.hasPermission !== this.props.hasPermission) {
      this.setState({ hasPermission: this.props.hasPermission });
    }
  }

  handleLinkClick = (e, path) => {
    if (!this.state.hasPermission) {
      e.preventDefault();
      if (window.$) {
        window.$('#logoutModal').modal('show');
      }
    } else {
      window.location.href = path;
    }
  }
  
  render() {
    return (
      <>
      <div style={{ height: "100vh", overflow: "auto", overflowY: "hidden" }}>
        <div id="index" className="h-100 element" data-bg={this.props.company == "HAS" ? "HAS" : "CPLS"}>
          <br />
          <nav className="navbar d-flex justify-content-between active row">
            <div className=" col-9 col-sm-6 col-md-6 col-lg-4 col-xl-4">
              <img
                style={{ maxWidth: "100%", maxHeight: "70px" }}
                src={this.props.company == "HAS" ? `${process.env.PUBLIC_URL}/Images/Landing_CompanyLogo_HAS.png` : `${process.env.PUBLIC_URL}/Images/Landing_CompanyLogo.png`}
              />
            </div>
            <div className="col-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
              <div className="d-flex justify-content-end">
                {/* <a
                  id="landingAdminAccess"
                  href={`${process.env.PUBLIC_URL}/uisweb"
                  placeholder="Admin Access Only"
                  className="w-100 d-flex justify-content-end"
                >
                  <img
                    className="card-img-top"
                    src={`${process.env.PUBLIC_URL}/Images/Landing_AdminLogin.png`}
                    alt="Card image cap"
                  />
                </a> */}
              </div>
            </div>
          </nav>
          <div id="landing" className="col-12">
            <div
              id="landingTitle"
              className="row font-weight-bold text-center d-flex justify-content-center align-items-end "
            >
              Welcome to UIS
            </div>
            <div id="landingCardDeck" className="card-deck col-12">
              <div className="card text-center col-12  d-flex justify-content-center">
                <a href={`${process.env.PUBLIC_URL}/home/application`}
                   onClick={(e) => this.handleLinkClick(e, `${process.env.PUBLIC_URL}/home/application`)}
                   style={{ cursor: this.state.hasPermission ? 'pointer' : 'not-allowed', opacity: this.state.hasPermission ? 1 : 0.6 }}>
                  <br />
                  <img width="100px" src={`${process.env.PUBLIC_URL}/Images/Landing_Application.png`} />
                  <div className="">
                    <h5 className="card-title " style={{ marginTop: ".75rem" }}>
                      Request
                      <br />
                      申請
                    </h5>
                  </div>
                </a>
              </div>
              <div className="card text-center col-12 d-flex justify-content-center">
                <a href={`${process.env.PUBLIC_URL}/home/measurement`}
                   onClick={(e) => this.handleLinkClick(e, `${process.env.PUBLIC_URL}/home/measurement`)}
                   style={{ cursor: this.state.hasPermission ? 'pointer' : 'not-allowed', opacity: this.state.hasPermission ? 1 : 0.6 }}>
                  <br />
                  <img width="100px" src={`${process.env.PUBLIC_URL}/Images/Landing_Measurement.png`} />
                  <div className="">
                    <h5 className="card-title " style={{ marginTop: ".75rem" }}>
                      Measurement / Size Fitting
                      <br />
                      度身 / 試身
                    </h5>
                  </div>
                </a>
              </div>

              <div className="card text-center col-12 d-flex justify-content-center">
                <a href={`${process.env.PUBLIC_URL}/home/customercollection`}
                   onClick={(e) => this.handleLinkClick(e, `${process.env.PUBLIC_URL}/home/customercollection`)}
                   style={{ cursor: this.state.hasPermission ? 'pointer' : 'not-allowed', opacity: this.state.hasPermission ? 1 : 0.6 }}>
                  <br />
                  <img width="100px" src={`${process.env.PUBLIC_URL}/Images/Landing_Collection.png`} />
                  <div className="">
                    <h5 className="card-title " style={{ marginTop: ".75rem" }}>
                      Collection
                      <br />
                      簽收
                    </h5>
                  </div>
                </a>
              </div>
              <div className="card text-center col-12 d-flex justify-content-center">
                <a href={`${process.env.PUBLIC_URL}/home/customerreturn`}
                   onClick={(e) => this.handleLinkClick(e, `${process.env.PUBLIC_URL}/home/customerreturn`)}
                   style={{ cursor: this.state.hasPermission ? 'pointer' : 'not-allowed', opacity: this.state.hasPermission ? 1 : 0.6 }}>
                  <br />
                  <img width="100px" src={`${process.env.PUBLIC_URL}/Images/Landing_Return.png`} />
                  <div className="">
                    <h5 className="card-title " style={{ marginTop: ".75rem" }}>
                      Return
                      <br />
                      歸還
                    </h5>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
          className="modal fade"
          id="logoutModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exitModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exitModalLabel">Warning</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">{ config.NO_AUTH_MSG }</div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default Homepage;
